







import Vue from "vue";
import Component from "vue-class-component";
import { Prop, PropSync } from "vue-property-decorator";

@Component({
  components: {},
})
export default class MoodboardImage extends Vue {
  @PropSync("src")
  private source!: string;
}
